<script setup lang="ts">
const { isLoggedIn } = useAccount();
const { cart } = useCart();
const createAccount = ref(false);

const { prefix: billingPrefix, ...billing } = cart.value.customer.billing;
const { prefix: shippingPrefix, ...shipping } = cart.value.customer.shipping;
const shipToDifferentAddress = ref(JSON.stringify(billing) !== JSON.stringify(shipping));
</script>

<template>
  <UiCheckoutStep :step="1" title="Détails de facturation">
    <div class="card-light space-y-4">
      <InputCustomerDetails :customer-details="cart.customer.billing" prefix="billing" />
      <label v-if="!isLoggedIn" class="form-boxed-item">
        <input id="createaccount" v-model="createAccount" type="checkbox" name="createaccount">
        <span>Créer un compte&nbsp;?</span>
      </label>
      <template v-if="isLoggedIn || createAccount">
        <UiField name="yith_birthday" label="Date de naissance" type="date" class="form-input" pattern="([0-9]{4})-(0[1-9]|1[012])-(0[1-9]|1[0-9]|2[0-9]|3[01])" placeholder="AAAA-MM-JJ" />
      </template>
    </div>
    <label class="form-boxed-item h4 text-primary">
      <input id="ship_to_different_address" v-model="shipToDifferentAddress" type="checkbox" name="ship_to_different_address" value="1">
      <span>Expédier à une adresse différente&nbsp;?</span>
    </label>
    <div v-show="shipToDifferentAddress" class="card-light">
      <InputCustomerDetails :customer-details="cart.customer.shipping" prefix="shipping" />
    </div>
    <CheckoutOrderComments />
  </UiCheckoutStep>
</template>
